import { getBaseUrl } from "../../common/jsonRpcRoutes";

/**
 * Prepends the Guest Checkout server origin to an asset path.
 *
 * When the MFE is embedded on a third-party page, static asset imports resolve
 * to relative paths (e.g. `/assets/dmn_logo-abc123.png`). Without a prefix
 * those requests go to the embedding page's origin and 404.
 *
 * Call this function at render time (inside JSX or a component body) rather
 * than at module initialisation level, so that the base URL set by the
 * `base-url` attribute is already available.
 *
 * @example
 * import dmnLogo from "../../assets/dmn_logo.png";
 * // ...
 * <img src={assetUrl(dmnLogo)} alt="DMN Logo" />
 */
export function assetUrl(path: string): string {
  const base = getBaseUrl();
  // Nothing to prepend when no base URL is configured (non-MFE usage).
  if (!base) return path;
  // Data URIs and already-absolute URLs must not be prefixed.
  if (path.startsWith("data:") || path.startsWith("http://") || path.startsWith("https://")) return path;
  // Avoid double-slashes: path already starts with "/" from Vite's asset hash.
  return base + path;
}
